module.exports = __webpack_public_path__ + "static/media/booksWithScheme.48c50049.svg";